import type { RootState } from '@generalTypes/rootStateTypes';
import { KovResourcePicker } from '@kathondvla/react-shared-components/src/components';
import type { EditAsideLeerlijnReference } from '@nodeTypeConfig/configTypes';
import {
  addRelationAction,
  patchRelationAction,
  removeRelationAction,
} from '@store/actions/documentActions';
import { getResourceKey } from '@store/helpers/documentHelpers';
import { any } from 'prop-types';
import type React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useEditHref } from '../../../hooks/UseEditHref';
import {
  selectLeerlijnReference,
  selectLeerlijnReferenceGoals,
  selectLeerlijnReferenceSelectedGoal,
} from './AsideLeerlijnReferenceSelectors';

const AsideLeerlijnReference: React.FC<{
  config: EditAsideLeerlijnReference;
  readonly: boolean;
}> = ({ config, readonly }) => {
  const dispatch = useDispatch();
  const editHref = useEditHref();

  const goals = useSelector((state: RootState) => selectLeerlijnReferenceGoals(state));
  const relation = useSelector((state: RootState) => selectLeerlijnReference(state));
  const selectedGoal = useSelector(
    (state: RootState) => selectLeerlijnReferenceSelectedGoal(state) ?? null,
  );

  const onChange = (newValue: ReturnType<typeof selectLeerlijnReferenceGoals>[0]) => {
    if (relation) {
      if (newValue) {
        dispatch(patchRelationAction(relation.key, { to: { href: newValue.href } }));
      } else {
        dispatch(removeRelationAction(relation.key));
      }
    } else {
      dispatch(
        addRelationAction({
          relationtype: 'REFERENCES',
          strength: 'MEDIUM',
          from: {
            href: `/content/${getResourceKey(editHref)}`,
          },
          to: {
            href: newValue.href,
          },
        }),
      );
    }
  };

  return (
    <div className="row">
      <div className="col-md-12">
        {config.label && <label className="control-label">{config.label}</label>}
      </div>
      <div className="col-md-12">
        <KovResourcePicker
          localData={goals}
          display="title"
          value={selectedGoal}
          clearable={true}
          disabled={readonly}
          onChange={onChange}
          optionValue={(o) => o.href}
          optionTemplate={(o) => (
            <strong>
              <span
                style={{
                  ...(o.color && { color: o.color }),
                }}
              >
                {o.identifier}
              </span>
              - {o.title}
            </strong>
          )}
        />
      </div>
    </div>
  );
};

AsideLeerlijnReference.displayName = 'AsideLeerlijnReference';

export default AsideLeerlijnReference;

AsideLeerlijnReference.propTypes = {
  config: any,
  readonly: any,
};
